import {useTranslation} from "react-i18next";

const useTranslatedTitles = props => {
    const {t} = useTranslation();

    const {selectedNode, trackInfo, videosFromSpeaker} = props;

    const selectedNodeName = selectedNode?.name || t("TRACKPAGE.CAROUSELS.SELECTED_NODE");
    const trackName = trackInfo?.name || t("TRACKPAGE.CAROUSELS.THIS_TRACK");
    const speakerName = videosFromSpeaker?.[0]?.name;
    const videoSpeaker = speakerName || t("TRACKPAGE.CAROUSELS.THIS_SPEAKER");

    //translations:
    const allVideosTitle = t("TRACKPAGE.CAROUSELS.ALL_VIDEOS", {trackName});
    const videosWord = t("TRACKPAGE.CAROUSELS.VIDEOS");
    const selectedVideoCarouselTitle = t("TRACKPAGE.CAROUSELS.SELECTEDVIDEO");
    const speakersVideosTitle = t("TRACKPAGE.CAROUSELS.SPEAKER_VIDEOS", {videoSpeaker});
    const videosOfSpeaker = t("TRACKPAGE.CAROUSELS.VIDEOSOFSPEAKER_PREFIX", {speakerName});
    const prefixSpeakersVideos = speakerName ? videosOfSpeaker : videosWord;

    const videosAboutCurrentTrack = t("TRACKPAGE.CAROUSELS.VIDEOS_ABOUT_CURRENT_TRACK", {selectedNodeName, trackName});
    const videosAboutOtherTracks = t("TRACKPAGE.CAROUSELS.VIDEOS_ABOUT_OTHER_TRACKS", {selectedNodeName});
    const videosMentionedInCurrentSelectionTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_MENTIONED_CURRENT_SELECTION", {
        prefixSpeakersVideos,
        selectedNodeName,
    });
    const videosAboutInCurrentSelectionTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_ABOUT_CURRENT_SELECTION", {
        prefixSpeakersVideos,
        selectedNodeName,
    });
    const videosMentionedInCurrentTrackTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_MENTIONED_CURRENT_TRACK", {
        prefixSpeakersVideos,
        selectedNodeName,
        trackName,
    });
    const videosAboutInCurrentTrackTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_ABOUT_CURRENT_TRACK", {
        prefixSpeakersVideos,
        selectedNodeName,
        trackName,
    });
    const videosMentionedInOtherTracksTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_MENTIONED_OTHER_TRACKS", {
        prefixSpeakersVideos,
        selectedNodeName,
    });
    const videosAboutInOtherTracksTitle = t("TRACKPAGE.CAROUSELS.SPEAKERVIDEOS_ABOUT_OTHER_TRACKS", {
        prefixSpeakersVideos,
        selectedNodeName,
    });

    return {
        allVideosTitle,
        selectedVideoCarouselTitle,
        speakersVideosTitle,
        videosAboutCurrentTrack,
        videosAboutOtherTracks,
        videosMentionedInCurrentSelectionTitle,
        videosAboutInCurrentSelectionTitle,
        videosMentionedInCurrentTrackTitle,
        videosAboutInCurrentTrackTitle,
        videosMentionedInOtherTracksTitle,
        videosAboutInOtherTracksTitle,
    };
};

export default useTranslatedTitles;
